import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useReqisterEquipmentMutation } from 'api';
import { EquipmentFormValues } from 'types';

import { formValuesAdapter } from '../adapter';

export function useRegisterEquipmentForm(onClose?: () => void) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { registerEquipmentMutation, isLoading, isSuccess } = useReqisterEquipmentMutation({
    successText: t('toasts.equipments.success.register'),
  });

  const handleSubmit = useCallback(
    async (data: EquipmentFormValues, attachmentIds: string[]) => {
      await registerEquipmentMutation({
        data: {
          ...formValuesAdapter(data),
          ...(!!attachmentIds?.length && { file_ids: attachmentIds }),
        },
        userId: data.user,
      });
    },
    [registerEquipmentMutation],
  );

  useEffect(() => {
    if (isSuccess) onClose ? onClose() : navigate(-1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return {
    handleSubmit,
    isLoading,
  };
}
